import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import Index from "./index";
import Edit from "./edit";

export default class Base extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/objects" component={Index}/>
                    <Route path="/objects/create" component={Edit}/>
                    <Route path="/objects/:id" component={Edit}/>
                </Switch>
        )
    }
}
